import { defineComponent, useCssVars, unref, computed, resolveComponent, openBlock, createElementBlock, normalizeStyle, createVNode } from 'vue';

const __default__ = defineComponent({
  name: 'Margin'
});

var script = /*#__PURE__*/defineComponent({ ...__default__,
  props: {
    block: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    const props = __props;

    useCssVars(_ctx => ({
      "44080de4": unref(margin),
      "753a8e79": unref(marginMedium),
      "8d346892": unref(marginLarge)
    }));

    const margin = computed(() => props.block.margin);
    const marginMedium = computed(() => props.block.marginMedium || props.block.margin);
    const marginLarge = computed(() => props.block.marginLarge || props.block.marginMedium || props.block.margin);
    const style = computed(() => props.block.backgroundColor ? `background-color: ${props.block.backgroundColor}` : '');
    return (_ctx, _cache) => {
      const _component_blocks_repeater = resolveComponent("blocks-repeater");

      return openBlock(), createElementBlock("div", {
        class: "margin-block",
        style: normalizeStyle(unref(style))
      }, [createVNode(_component_blocks_repeater, {
        blocks: props.block.blocks
      }, null, 8, ["blocks"])], 4);
    };
  }

});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\n.margin-block {\r\n  margin: var(--44080de4);\n}\n@media (min-width: 768px) {\n.margin-block {\r\n    margin: var(--753a8e79);\n}\n}\n@media (min-width: 1024px) {\n.margin-block {\r\n    margin: var(--8d346892);\n}\n}\r\n\r\n";
styleInject(css_248z);

// Import vue component

// Default export is installable instance of component.
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),
var entry_esm = /*#__PURE__*/(() => {
  // Assign InstallableComponent type
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('StoryblokMargin', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
